import {Injectable} from 'ng-metadata/core';
import {PushtoService} from "../pushto.service";

@Injectable()
export class EndNoteService {
    private popupWin: Window;

    constructor(private pushtoService: PushtoService){

    }

    public endNoteAction(item, selectedIds){
        this.popupWin = window.open('', '_blank');
        let failedAction = angular.bind(this, this.failedPushtoAction);
        let successAction = angular.bind(this, this.successfullPushtoAction);
        let pushtoPromise = this.pushtoService.getServiceUrl([item], selectedIds, 'endnote');
        pushtoPromise.then((response)=>successAction(response), (response)=>failedAction(response));
    }

    private successfullPushtoAction(response) {
        let serviceUrl = response.data.serviceUrl;
        this.popupWin.document.open();
        this.popupWin.document.write(`<html>
                                            <head>
                                                <link rel="stylesheet" type="text/css" href="style.css" />
                                                <meta http-equiv="refresh" content="1; url=${serviceUrl}" />
                                                </head>
                                                <body></body></html>`);
        this.popupWin.document.close();

        console.log("Endnote successfully sent");
    }

    private failedPushtoAction(response) {
        console.log("Endnote call failed");
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/endNoteAction/endNote.service.ts